import React, { useState } from "react";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
} from "react-google-places-autocomplete";
import Button from "@material-ui/core/Button";
interface Props {
  onChangeAddressValue: (latitude: number, longitude: number) => void;
  onClearClick: () => void;
}

const AddressSearchBar: React.FunctionComponent<Props> = ({
  onChangeAddressValue,
  onClearClick
}) => {
  const [address, setAddress] = useState<any>(null);

  const onChangeAddress = (v) => {
    if (v) {
      setAddress(v);
      geocodeByAddress(v.label)
        .then((results) => {
          if (results.length > 0) {
            onChangeAddressValue(
              results[0].geometry.location.lat(),
              results[0].geometry.location.lng()
            );
          } else {
          }
        })
        .catch((error) => {
          console.log("errror 232", error);
        });
    } else {
    }
  };
// style={{height: '300px'}}
  return (
    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}} >
    <GooglePlacesAutocomplete
      apiKey={process.env.React_App_GEOCODE_KEY}
      selectProps={{
        value: address,
        onChange: (v) => onChangeAddress(v),
        placeholder: "Search Places...",
        styles: {
          input: (provided) => ({
            ...provided,
            width: "250px",
            
          }),
          option: (provided) => ({
            ...provided,
          }),
          singleValue: (base, state) => ({
            ...base,
            color: state.selectProps.menuIsOpen ? "#DCDCDC" : base.color,
          }),
        },
      }}
    />
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setAddress('')
            onClearClick()
          }}
          style={
         {   minWidth: "40px",
            height: "25px",
            borderRadius: "5px",
            fontSize: "13px",
            letterSpacing: "0.5px",
            fontWeight: 600,
            padding: "0px 0px 0px 0px !important",
            marginLeft: "9px"}
          }
        >
          REMOVE
        </Button>
    </div>
  );
};

export default AddressSearchBar;
